<template>
  <el-popover
    placement="bottom-start"
    :offset="-100"
    width="434"
    trigger="hover"
    popper-class="warehousePopover">
    <div slot="reference">
      <i class="iconfont icon-help pointer" style="margin-left:4px;color:#909399;"></i>
    </div>
    <div style="border: 10px solid #A075D4;padding: 10px 36px;border-radius:6px">
      <div class="f f--c">
        <img src="@/assets/img/languages/zh-CN.png" class="languageImg" style="width:18px;height:14px;margin-right:4px">
        <span>{{ $t('Index.ShoppingCar.China') }}</span>
      </div>
      <div style="color:#8B93A3;margin-bottom:10px; word-break:keep-all;">{{ $t('Index.ShoppingCar.Tips1') }}</div>
      <div class="f f--c">
        <img src="@/assets/img/languages/en.png" style="width:18px;height:14px;margin-right:4px">
        <span style="margin-right:12px">US</span>
        <img src="@/assets/img/languages/UK.png" style="width:18px;height:14px;margin-right:4px">
        <span style="margin-right:12px">UK</span>
        <img src="@/assets/img/languages/de.png" style="width:18px;height:14px;margin-right:4px">
        <span style="margin-right:12px">{{ $t('Index.ShoppingCar.Germany') }}</span>
      </div>
      <div style="color:#8B93A3;margin-bottom:14px;word-break:keep-all;width:106%;">{{ $t('Index.ShoppingCar.Tips2') }}</div>
      <div style="color:#A075D4;padding:8px 12px;border: 1px dashed #A075D4;border-radius: 6px;margin-bottom:10px; word-break:keep-all;width:106%;">{{ $t('Index.ShoppingCar.Tips3') }}</div>
    </div>
  </el-popover>
</template>

<script>
export default {

}
</script>

<style>

</style>
